/**
 *
 * AppGenerated
 *
 * This component is the skeleton around the actual pages, and should only
 * contain code that should be seen on all pages. (e.g. navigation bar)
 */

import React from 'react';
import { StyleSheetManager } from 'styled-components';
import isPropValid from '@emotion/is-prop-valid';
import GlobalStyle from '../../global-styles';


function AppGenerated(props) {
  return (
    <>
      <GlobalStyle />
      <StyleSheetManager  shouldForwardProp={isPropValid}>
        {React.Children.toArray(props.children)}
      </StyleSheetManager>
    </>
  );
}



export default AppGenerated;
